import { Component, OnInit, Type, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ReportCategoryModel } from '../models/ReportCategoryModel';
import { SsrsConfigModel } from '../models/SsrsConfigModel';
import { GetSsrsConfigAction, GetReportsQueryAction } from '../store/actions';
import * as fromStore from '../store/reducers';
import { IReportModel } from '../models/IReportModel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-report-dashboard',
  templateUrl: './report-dashboard.component.html',
  styleUrls: ['./report-dashboard.component.scss']
})
export class ReportDashboardComponent implements OnInit {
  displayedColumns = ['name'];
  static dashboardName = 'report';
  ssrsReportCategories$: Observable<ReportCategoryModel[]>;
  ssrsConfig: SsrsConfigModel;
  loading = true;
  triedLoading = false;
  selectedReport: IReportModel;

  accessSsrsPermission = "ReportingModule.SsrsPortal:Access";

  constructor(private store: Store<any>) { }

  ngOnInit() {

    this.store.select(fromStore.getSsrsConfig)
      .subscribe(config => {
        if (config) {
          this.ssrsConfig = config;
          this.store.dispatch(new GetReportsQueryAction({ page: 0, pageSize: 200 }));
          this.loading = false;
        } else if (!this.triedLoading) {
          this.triedLoading = true;
          this.store.dispatch(new GetSsrsConfigAction());
        } else {
          this.loading = false;
        }
      });

    this.ssrsReportCategories$ = this.store.select(fromStore.getSsrsCategories);
  }

  openSsrsReportManager() {
    if (this.ssrsConfig) {
      window.open(this.ssrsConfig.reportManagerUrl, "_blank");
    }
  }

  selectReport(report: IReportModel) {
    this.selectedReport = report;
  }

  clearSelectedReport() {
    this.selectedReport = undefined;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    //Keep this method here as it causes an angular digest which keeps the sidnav width correctly updated
  }
}



// WEBPACK FOOTER //
// ./src/app/report/components/report-dashboard.component.ts